import { error } from "@multimediallc/logging"
import { PartType } from "@multimediallc/web-utils/types"
import { Fragment } from "react/jsx-runtime"
import { MessageParts } from "../MessageParts"
import { HashtagPart } from "../MessageParts/HashtagPart"
import { UsernameLabel } from "../UsernameLabel"
import type {
    IRoomNotice,
    IRoomNoticePart,
} from "@multimediallc/web-utils/types"

import "./RoomNotice.scss"

interface RoomNoticeProps {
    noticeData: IRoomNotice
}

export function RoomNotice({
    noticeData: { messages, shortcodes },
}: RoomNoticeProps) {
    const renderPart = (part: IRoomNoticePart) => {
        switch (part.partType) {
            case PartType.message:
                if (part.message === undefined) {
                    return undefined
                }
                return (
                    <MessageParts
                        message={part.message}
                        shortcodes={shortcodes}
                    />
                )
            case PartType.user:
                return <UsernameLabel user={part.user!} />
            case PartType.hashtag:
                return <HashtagPart hashtag={part.message!} />
            default:
                error(`Invalid RoomNotice type: ${part.partType}`, part)
        }
    }

    return (
        <div className="RoomNotice" data-testid="room-notice">
            {messages.map((parts: IRoomNoticePart[], i: number) => {
                return (
                    <div key={i}>
                        {parts.map((part: IRoomNoticePart, j: number) => {
                            return (
                                <Fragment key={j}>{renderPart(part)} </Fragment>
                            )
                        })}
                    </div>
                )
            })}
        </div>
    )
}
